module.exports = __webpack_public_path__ + "img/inteligenciaejecutiva.12b37936.png";